import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { httpStatus } from './api-errors';
import { authApi, type PlatformAdmin } from './auth-api';

import { useAuthStore } from '@/stores/auth';

export const adminDisplayName = (admin: PlatformAdmin): string =>
  [admin.firstName, admin.lastName].filter(Boolean).join(' ') || admin.email;

export const useAuth = () => {
  const accessToken = useAuthStore((s) => s.accessToken);
  const admin = useAuthStore((s) => s.admin);
  const setAuth = useAuthStore((s) => s.setAuth);
  const clearAuth = useAuthStore((s) => s.clearAuth);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  // Pas de révocation serveur en V1 : le POST trace le LOGOUT, le jeton est jeté côté client quoi qu'il arrive
  const logout = useCallback(async () => {
    try {
      await authApi.logout();
    } catch (err) {
      // Jeton déjà expiré : l'intercepteur a nettoyé la session et redirigé vers /login « Session expirée »
      if (httpStatus(err) === 401) return;
      // API injoignable : la session locale part quand même
    }
    clearAuth();
    queryClient.clear();
    await navigate({ to: '/login', replace: true });
  }, [clearAuth, queryClient, navigate]);

  return { accessToken, admin, isAuthenticated: Boolean(accessToken), setAuth, clearAuth, logout };
};
